import * as React from 'react';
import {MenuItem, Menu} from '../../../ui-library';
import DropDownBtnController from '../Controllers/DropDownBtn.controller';
import {AllClasses} from '../Style/DropDownBtn.style';

const DropDownBtn = ({ manualRefinementState, setApproved, imageIndex, removeChosenClass}) => {

    const {handleOpenMenu, open, anchorEl, handleCloseMenu, handleChoseClass} = DropDownBtnController(setApproved, imageIndex, removeChosenClass);


    return (
        <>
            <AllClasses onClick={handleOpenMenu} />
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleCloseMenu}
            >
                {manualRefinementState.classes.map((curClass) => (
                    <MenuItem key={curClass.tagId} onClick={() => handleChoseClass(curClass)}>
                        {curClass.name}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};

export default DropDownBtn;
